import axios from 'axios'
import Requester from './Requester'

export const apiLimitReturned = 10
export const requesterConfiguratorMethods = {
  GET_BRANDS: 'getMakes',
  GET_GROUP_MODELS: 'getGroupModels',
  GET_MODELS: 'getModels',
  GET_FINISHES: 'getTrims',
  GET_ENERGIES: 'getFuels',
  GET_VERSIONS: 'getVersion',
  GET_PICTURES: 'getPictures',
  GET_EQUIPMENTS: 'getEquipments',
  GET_PAINTS: 'getPaints',
  GET_SADDLERIES: 'getSaddleries',
  GET_COLORS: 'getColors',
  GET_DESIGN: 'getDesign',
  GET_SERVICE_AGREEMENTS: 'getServiceAgreements'
}

/**
 * The Request class allows you to centralize calls to the outside of the application, including the server
 */
class RequesterConfigurator extends Requester {
  /**
   * Réalise des appels vers l'API
   *
   * @param {string} action le nom de l'action à réaliser
   * @param {*} params un objet de paramètres
   * @static
   * @return {Promise} une promesse en général avec les données de retour
   */
  static get = (action, params, redirectMessage, addParamsEntityPOS) => {
    if (action === requesterConfiguratorMethods.GET_BRANDS) {
      return RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: '/configurators/nc/makes',
        params: {
          pointOfSale: true
        },
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterConfiguratorMethods.GET_GROUP_MODELS) {
      const { brand } = params
      return RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: `/configurators/nc/makes/${brand}/group-models`,
        params: {},
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterConfiguratorMethods.GET_MODELS) {
      const { groupModel, brand } = params

      return RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: `/configurators/nc/makes/${brand}/models`,
        params: {
          groupModel
        },
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterConfiguratorMethods.GET_FINISHES) {
      const { date, brand, model } = params

      return RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: `/configurators/nc/makes/${brand}/models/${model}/trims`,
        params: {
          putIntoService: date
        },
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterConfiguratorMethods.GET_ENERGIES) {
      const { date, brand, model } = params

      return RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: `/configurators/nc/makes/${brand}/models/${model}/fuels`,
        params: {
          putIntoService: date
        },
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterConfiguratorMethods.GET_VERSIONS) {
      const { date, brand, model, energy, finishes } = params

      return RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: `/configurators/nc/makes/${brand}/models/${model}/versions`,

        params: {
          putIntoService: date,
          fuels: energy,
          trim: finishes
        },
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterConfiguratorMethods.GET_PICTURES) {
      const { id } = params

      return RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: `configurators/cars/${id}/pictures`
      })
    }

    if (action === requesterConfiguratorMethods.GET_SERVICE_AGREEMENTS) {
      const { id, catalog } = params

      return RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: `/configurators/cars/${id}/service-agreements`,
        params: {
          catalog
        },
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterConfiguratorMethods.GET_EQUIPMENTS) {
      const { id, catalog } = params

      return RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: `/configurators/cars/${id}/equipments`,
        params: {
          group: true,
          catalog
          // type: ['serial']
        },
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterConfiguratorMethods.GET_PAINTS) {
      const { id, catalog } = params

      return RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: `/configurators/cars/${id}/paints`,
        params: { catalog },
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterConfiguratorMethods.GET_SADDLERIES) {
      const { id, catalog } = params

      return RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: `/configurators/cars/${id}/saddleries`,
        params: { catalog },
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterConfiguratorMethods.GET_COLORS) {
      const { brand, model } = params

      return RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: `/configurators/nc/makes/${brand}/models/${model}/colors`,
        params: {},
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterConfiguratorMethods.GET_DESIGN) {
      const { brand, model, id, catalog } = params

      const requestColor = RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: `/configurators/nc/makes/${brand}/models/${model}/colors`,
        params: {},
        redirectMessage,
        addParamsEntityPOS
      })
      const requestSaddleries = RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: `/configurators/cars/${id}/saddleries`,
        params: { catalog },
        redirectMessage,
        addParamsEntityPOS
      })
      const requestPaints = RequesterConfigurator.getRequest({
        urlApi: 'urlConfigurator',
        url: `/configurators/cars/${id}/paints`,
        params: { catalog },
        redirectMessage,
        addParamsEntityPOS
      })

      const requests = [requestColor, requestSaddleries, requestPaints]
      return new Promise((resolve, reject) => {
        axios
          .all(requests)
          .then(
            axios.spread((colorsResponse, saddleriesResponse, paintsResponse) => {
              if (colorsResponse.error) {
                if (colorsResponse.error.message) reject(colorsResponse.error.message)

                reject(colorsResponse.error)
              }
              if (saddleriesResponse.error) {
                if (saddleriesResponse.error.message) reject(saddleriesResponse.error.message)

                reject(saddleriesResponse.error)
              }
              if (paintsResponse.error) {
                if (paintsResponse.error.message) reject(paintsResponse.error.message)

                reject(paintsResponse.error)
              }

              const response = {
                colors: colorsResponse.colors,
                leathers: saddleriesResponse.leathers,
                fabrics: saddleriesResponse.fabrics,
                paints: paintsResponse.paints
              }
              resolve(response)
            })
          )
          .catch(error => {
            reject(error)
          })
      })
    }

    return null
  }
}

export default RequesterConfigurator
